//import injectionTarget from "../core/di/DecoratorInjectionTarget.ts";
import { IPersonState } from "../repositories/dto/user/IPersonState.ts";
import type IUserRepository from "../repositories/interfaces/IUserRepository.ts";
import { IChallengeResponse } from "../repositories/dto/user/IChallengeResponse.ts";
import { ISolutionResponse } from "../repositories/dto/user/ISolutionResponse.ts";
import { IRepositoryError } from "../repositories/dto/errors/IRepositoryError.ts";
import Container from "../core/di/DependencyContainer.ts";
import { IMfaChallengePurpose } from "@/repositories/implementations/UserRepository.ts";
import BaseService from "@/services/BaseService.ts";
import { IVerifyToken } from "@/repositories/dto/user/IVerifyToken.ts";

//@injectionTarget()
export default class PersonService extends BaseService {
  userRepository: IUserRepository;

  constructor(
    //@inject("userRepository") userRepository?: IUserRepository
  ) {
    super();
    let userRepository: IUserRepository | null = Container.get("userRepository");
    // ensures userRepository exists and no checks for undefined are required throughout the class
    if (userRepository == null) {
      throw Error("No UserRepository provided or injected.");
    }
    this.userRepository = userRepository;
  }

  async getState(): Promise<IPersonState | null> {
    return (await this.userRepository.getState()) ?? null;
  }

  async getChallenge(purpose: IMfaChallengePurpose, challengeCode: string | null): Promise<IChallengeResponse | IRepositoryError> {
    try {
      return (await this.userRepository.getChallenge(purpose, challengeCode))!;
    } catch (error: any) {
      return {
        code: error.code ?? 100000,
        type: error.type ?? "ERROR_CHALLENGE_COMMON",
        description: error.message ?? error.description ?? "Unexpected error occured"
      } as IRepositoryError;
    }
  }

  async verifySolution(challengeCode: string, solutionCode: string): Promise<ISolutionResponse | IRepositoryError> {
    try {
      return (await this.userRepository.verifySolution(challengeCode, solutionCode))!;
    } catch (error: any) {
      return {
        code: error.code ?? 100000,
        type: error.type ?? "ERROR_CHALLENGE_COMMON",
        description: error.message ?? error.description ?? "Unexpected error occured"
      } as IRepositoryError;
    }
  }

  async addPhone(countryCode: string, phone: string): Promise<IChallengeResponse | IRepositoryError> {
    try {
      return (await this.userRepository.addPhone(countryCode, phone)) as IChallengeResponse | IRepositoryError;
    } catch (error: any) {
      console.log("user.service.error", error);
      return {
        code: error.code ?? 100000,
        type: error.type ?? "ERROR_CHALLENGE_COMMON",
        description: error.message ?? error.description ?? "Unexpected error occured"
      } as IRepositoryError;
    }
  }

  async createPersonalProfile(refKey: string, questionnaire: object): Promise<void> {
    await this.refWrapper(refKey, () => {
      return this.userRepository.createPersonalProfile(questionnaire);
    });
  }

  async createPersonalQuestionnaire(refKey: string, questionnaire: object): Promise<void> {
    await this.refWrapper(refKey, () => {
      return this.userRepository.createPersonalQuestionnaire(questionnaire);
    });
  }

  async getVerifyToken(): Promise<IVerifyToken | IRepositoryError> {
    return (await this.userRepository.getVerifyToken())!;
  }

  async updateReviewStatus(): Promise<void | IRepositoryError> {
    return (await this.userRepository.updateReviewStatus()) as void | IRepositoryError;
  }

  async createBusinessProfile(refKey: string, profile: object): Promise<void> {
    await this.refWrapper(refKey, () => {
      return this.userRepository.createBusinessProfile(profile);
    });
  }

  async createBusinessOwners(refKey: string, owners: object): Promise<void> {
    await this.refWrapper(refKey, () => {
      return this.userRepository.createBusinessOwners(owners);
    });
  }
}
